require('../styles.css');
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/icons/monochrome/IconMarketing.tsx
var IconMarketing_exports = {};
__export(IconMarketing_exports, {
  default: () => IconMarketing_default
});
module.exports = __toCommonJS(IconMarketing_exports);

// src/assets/monochrome/marketing.svg
var import_jsx_runtime = require("react/jsx-runtime");
var SvgMarketing = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.99954 2.2002C4.37362 2.2002 3.86621 2.70761 3.86621 3.33353V16.6669C3.86621 17.2928 4.37362 17.8002 4.99954 17.8002H14.9995C15.6255 17.8002 16.1329 17.2928 16.1329 16.6669V3.33353C16.1329 2.70761 15.6255 2.2002 14.9995 2.2002H4.99954ZM5.63288 16.0335V3.96686H14.3662V16.0335H5.63288ZM7.81981 5.3002C7.36679 5.3002 6.99954 5.66744 6.99954 6.12047C6.99954 6.57349 7.36679 6.94074 7.81981 6.94074H12.2793C12.7323 6.94074 13.0995 6.57349 13.0995 6.12047C13.0995 5.66744 12.7323 5.3002 12.2793 5.3002H7.81981ZM7.81981 8.30019C7.36679 8.30019 6.99954 8.66744 6.99954 9.12046C6.99954 9.57349 7.36679 9.94073 7.81981 9.94073H9.27927C9.7323 9.94073 10.0995 9.57349 10.0995 9.12046C10.0995 8.66744 9.7323 8.30019 9.27927 8.30019H7.81981Z", fill: "#676F7E" }) });
var marketing_default = SvgMarketing;

// src/Wrappers/helpers.ts
var getIconBaseCssVariables = ({
  size,
  rotate,
  transitionDuration
}) => {
  return {
    "--icon-size": size ? `${size}px` : "100%",
    "--icon-rotate": rotate ? `${rotate}deg` : "0deg",
    // Browser cannot handle multiple transitions on the same property if another variable (e.g. --transition-duration)
    // is defined on another element.
    "--icon-transition-fill": transitionDuration ? `fill ${transitionDuration} ease` : "none",
    "--icon-transition-transform": transitionDuration ? `transform ${transitionDuration} ease` : "none"
  };
};
var getIconColoringCssVariables = ({
  state,
  color,
  activeColor
}) => {
  return {
    "--icon-color": state === "active" ? activeColor : color,
    "--icon-active-color": state === "disabled" || !activeColor ? color : activeColor
  };
};

// src/Wrappers/IconWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var getWrapperStyles = (props) => ({
  ...getIconBaseCssVariables(props),
  ...getIconColoringCssVariables(props)
});
var IconWrapper = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "div",
    {
      className: "ui-icon-size-wrapper ui-icon-coloring-wrapper",
      style: getWrapperStyles(props),
      children: props.children
    }
  );
};

// src/icons/monochrome/IconMarketing.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var IconMarketing = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(IconWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(marketing_default, {}) });
};
IconMarketing.displayName = "IconMarketing";
var IconMarketing_default = IconMarketing;
